import convertColor from '@packages/convert-color'
import * as React from 'react'
import { useEffect, useState } from 'react'

type IconProps = {
	iconName: string
	iconSize?: string
	iconStroke?: string
	iconColor?: string
}

// Функция для перевода атрибутов нативного SVG в React-пропсы
const convertAttrsToProps = (element: HTMLElement): Record<string, string> => {
	const props: Record<string, string> = {}
	for (const { name, value } of element.attributes) {
		props[name] = value
	}
	return props
}

// Главная функция: создание React-элемента из нативного SVG
const createSvgElement = (svgEl: HTMLElement): React.ReactElement => {
	const props = convertAttrsToProps(svgEl)
	const children = Array.from(svgEl.childNodes).map((child) => {
		if (child.nodeType === Node.ELEMENT_NODE) {
			return createSvgElement(child as HTMLElement)
		}
		return child.nodeValue || '' // Текстовые узлы
	})

	return React.createElement(svgEl.tagName.toLowerCase(), props, ...children)
}

// Компонент иконки
const IconSvg: React.FunctionComponent<IconProps> = ({
	iconName,
	iconSize = '24',
	iconStroke = '2',
	iconColor = 'currentColor',
}) => {
	const [svgElement, setSvgElement] = useState<HTMLElement | null>(null)

	// Получение обработанного цвета
	const color = convertColor(iconColor) || 'currentColor'

	useEffect(() => {
		async function loadSvg() {
			try {
				const response = await fetch(`https://cdn.jsdelivr.net/npm/@tabler/icons@latest/icons/${iconName}.svg`)
				if (response.ok) {
					const text = await response.text()
					const parser = new DOMParser().parseFromString(text, 'image/svg+xml')
					const svgElement = parser.documentElement


					// Установка атрибутов иконки
					svgElement.setAttribute('stroke', color)
					svgElement.setAttribute('stroke-width', iconStroke)
					svgElement.setAttribute('width', `${iconSize}px`)
					svgElement.setAttribute('height', `${iconSize}px`)
					svgElement.setAttribute('color', color)

					setSvgElement(svgElement)
				}
			} catch (error: any) {
				console.error('Ошибка при загрузке иконки:', error.message)
			}
		}

		loadSvg()
	}, [iconName, iconSize, iconStroke, iconColor])

	return svgElement ? createSvgElement(svgElement) : null
}

export default IconSvg

